import React from 'react';
import { View, StyleSheet, TouchableWithoutFeedback } from 'react-native';
import CarouselPaginationDot from './CarouselPaginationDot';
import PropTypes from 'prop-types';
import R from '../../core-res/R';
class CarouselPagination extends React.Component {
    constructor() {
        super(...arguments);
        this.handleDotClicked = index => {
            if (this.props.onDotClicked) {
                this.props.onDotClicked(index);
            }
        };
    }
    _renderDot(isActive, index) {
        const { dotStyle, activeDotStyle } = this.props;
        return (<TouchableWithoutFeedback key={`dotKey-${index}`} onPress={() => this.handleDotClicked(index)}>
        <View>
          <CarouselPaginationDot isActive={isActive} dotStyle={dotStyle} activeDotStyle={activeDotStyle}/>
        </View>
      </TouchableWithoutFeedback>);
    }
    render() {
        const { activeIndex, numberOfPage } = this.props;
        if (numberOfPage <= 1) {
            return null;
        }
        const children = [];
        for (let i = 0; i < numberOfPage; i++) {
            const isActive = i === activeIndex;
            children.push(this._renderDot(isActive, i));
        }
        return <View style={styles.container}>{children}</View>;
    }
}
CarouselPagination.propTypes = {
    activeIndex: PropTypes.number.isRequired,
    numberOfPage: PropTypes.number.isRequired,
    dotStyle: PropTypes.object,
    activeDotStyle: PropTypes.object,
    onDotClicked: PropTypes.func,
};
const styles = StyleSheet.create({
    container: {
        width: '100%',
        position: 'absolute',
        bottom: R.spacing.xs,
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'row',
    },
});
export default CarouselPagination;
